import { render, staticRenderFns } from "./Etalonv2.vue?vue&type=template&id=38d6ff65&"
import script from "./Etalonv2.vue?vue&type=script&lang=js&"
export * from "./Etalonv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports